export default {
  apiHost: import.meta.env.VITE_VUE_APP_API_HOST,
  version: import.meta.env.VITE_VUE_APP_VERSION,
  baseRoute: import.meta.env.VITE_VUE_APP_BASE_ROUTE
};
